import { render, staticRenderFns } from "./TourOverview.vue?vue&type=template&id=371eae8e&scoped=true&"
import script from "./TourOverview.vue?vue&type=script&lang=js&"
export * from "./TourOverview.vue?vue&type=script&lang=js&"
import style0 from "./TourOverview.vue?vue&type=style&index=0&id=371eae8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371eae8e",
  null
  
)

export default component.exports